import { useAuthContext } from "./useAuthContext";
import axios from "../functions/axios";


export const useLogout = () => {
  const { dispatch } = useAuthContext();

  const logout = () => {
    localStorage.removeItem('user');
    axios.defaults.headers.common['Authorization'] = null;
    dispatch({ type: 'LOGOUT' });
  };

  return {
    logout,
  };
}